<ng-container *ngIf="canCreateOrder$ | async; else noCatalog">
  <div class="catalog-header">
    <div class="flex gap-md align-items-center">
      <vnm-list-filter class="flex-1">
        <input
          type="search"
          pInputText
          [placeholder]="'product-catalog.search-placeholder' | translate"
          (input)="productCatalog.filter($event.target.value)"
          class="flex-1"
        />
      </vnm-list-filter>
      <vnm-shopping-cart-toggle [currentUser]="currentUser$ | async"></vnm-shopping-cart-toggle>
    </div>
    <div class="flex flex-wrap gap-md align-items-center">
      <vnm-list-filter class="flex-1" icon="filter">
        <p-multiSelect
          [options]="categories$ | async"
          [(ngModel)]="selectedCategories"
          [defaultLabel]="'product-catalog.category-filter-placeholder' | translate"
          display="chip"
          appendTo="body"
          class="w-full"
        ></p-multiSelect>
      </vnm-list-filter>
      <div class="flex flex-nowrap gap-md align-items-center ml-auto">
        <label class="ml-auto text-nowrap" translate>app.sort-by</label>
        <p-dropdown
          [options]="sortOptions | mit: 'product-catalog.sort-options' | async"
          [(ngModel)]="sortKey"
          [placeholder]="'product-catalog.sort-placeholder' | translate"
          (onChange)="onSortChange($event)"
          dropdownIcon="fa fa-fw fa-sort"
          appendTo="body"
        ></p-dropdown>
      </div>
      <!-- <p-dataViewLayoutOptions></p-dataViewLayoutOptions> -->
    </div>
  </div>

  <div class="flex flex-column gap-md p-4">
    <p-dataView
      #productCatalog
      [value]="products$ | async | dup | categoryFilter: $any(selectedCategories)"
      [paginator]="true"
      [rows]="25"
      [emptyMessage]="'product-catalog.empty-message' | translate"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      (onPage)="onPageCatalog()"
      loadingIcon="fas fa-spinner-third fa-spin"
      layout="list"
      filterBy="name,shortDescription,categories"
      vnmDataViewSortFix
      class="flex-1"
    >
      <ng-template pTemplate="listItem" let-product>
        <vnm-product-catalog-item [product]="product" class="col-12 mb-3"></vnm-product-catalog-item>
      </ng-template>
    </p-dataView>
  </div>
</ng-container>

<ng-template #noCatalog>
  <div class="catalog-header" translate>product-catalog.product-catalog-not-allowed</div>
</ng-template>
